import { Button, Card, Flex, Text } from '@chakra-ui/react';
import { memo, useCallback } from 'react';
import { LuDownload, LuEyeOff, LuUpload } from 'react-icons/lu';

interface Props {
  balance: number;
  availableToTrade: number;
  dailyChange: number;
  dailyChangePercent: number;
}

const PortfolioCard = ({ balance, availableToTrade, dailyChange, dailyChangePercent }: Props) => {
  const handleDeposit = useCallback(() => {
    // TODO: implement deposit
  }, []);

  const handleWithdraw = useCallback(() => {
    // TODO: implement withdraw
  }, []);

  const changeSign = dailyChange >= 0 ? '+' : '';
  const changeColor = dailyChange >= 0 ? 'green.600' : 'red.600';

  return (
    <Card.Root borderColor="border.light" borderRadius="xl" bg="surface.background" flex={1} h="full">
      <Card.Body p={5} gap={4}>
        <Flex direction="row" justifyContent="space-between" alignItems="flex-start">
          <Flex direction="column" gap={1}>
            <Flex direction="row" gap={2} alignItems="center">
              <Text fontSize="sm" color="text.secondary" fontWeight="medium">
                Portfolio
              </Text>
            </Flex>
            <Flex direction="row" gap={2} alignItems="center">
              <Text fontSize="3xl" fontWeight="bold">
                ${balance.toFixed(2)}
              </Text>
              <LuEyeOff color="var(--chakra-colors-text-secondary)" size={18} />
            </Flex>
            <Text fontSize="sm" color={changeColor}>
              {changeSign}${Math.abs(dailyChange).toFixed(2)} ({changeSign}
              {Math.abs(dailyChangePercent).toFixed(0)}%) past day
            </Text>
          </Flex>
          <Flex direction="column" alignItems="flex-end">
            <Text fontSize="xs" color="text.secondary">
              Available to trade
            </Text>
            <Text fontSize="xl" fontWeight="bold">
              ${availableToTrade.toFixed(2)}
            </Text>
          </Flex>
        </Flex>
        <Flex direction="row" gap={3} mt={1}>
          <Button flex={1} size="xs" borderRadius="md" onClick={handleDeposit}>
            <LuDownload />
            Deposit
          </Button>
          <Button
            flex={1}
            size="xs"
            borderRadius="md"
            variant="outline"
            borderColor="border.light"
            onClick={handleWithdraw}
          >
            <LuUpload />
            Withdraw
          </Button>
        </Flex>
      </Card.Body>
    </Card.Root>
  );
};

export default memo(PortfolioCard);
